import React, { useEffect, useState } from "react";
import { Table, Container, Button } from "react-bootstrap";
import { getTickets } from "../../../Service/AllTicketServiceAPI";

const SlaInprogressTicketList = () => {
    const [tickets, setTickets] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const rowsPerPage = 5;

    useEffect(() => {
        const fetchTickets = async () => {
            try {
                const role = sessionStorage.getItem("role");
                const userId = sessionStorage.getItem("pkUserId");
                const response = await getTickets({
                    ticketType: "SLA",
                    status: "IN_PROGRESS",
                    userId,
                    role,
                });
                setTickets(response.data || []);
            } catch (error) {
                console.error("Error fetching SLA in progress tickets:", error);
            }
        };
        fetchTickets();
    }, []);

    const indexOfLast = currentPage * rowsPerPage;
    const indexOfFirst = indexOfLast - rowsPerPage;
    const currentTickets = tickets.slice(indexOfFirst, indexOfLast);
    const totalPages = Math.ceil(tickets.length / rowsPerPage);

    const getPriorityStyle = (priority) => {
        let backgroundColor = "gray";
        if (priority === "HIGH") backgroundColor = "red";
        else if (priority === "MEDIUM") backgroundColor = "orange";
        else if (priority === "LOW") backgroundColor = "green";

        return {
            fontWeight: "bold",
            color: "white",
            backgroundColor,
            textAlign: "center"
        };
    };

    return (
        <Container className="mt-4">
            <h5 className="mb-3">In Progress SLA Tickets</h5>

            <div style={{ overflowX: "auto" }}>
                <Table striped bordered hover responsive style={{ backgroundColor: "white" }}>
                    <thead className="header-class">
                        <tr>
                            <th>Ticket No.</th>
                            <th>Ticket Type</th>
                              <th>Priority</th>
                            <th>Dispenser Sr No</th>
                            <th>Issue</th>
                            <th>RO Name</th>
                            <th>Address</th>
                            <th>City</th>
                            <th>State</th>
                            <th>Country</th>
                            <th>Contact</th>
                          
                            {/* <th>WO Status</th>
                            <th>OMC Approval</th> */}
                        </tr>
                    </thead>
                    <tbody>
                        {currentTickets.map((ticket, index) => (
                            <tr key={index}>
                                <td>{ticket.ticketNumber || "N/A"}</td>
                                <td>{ticket.ticketType || "N/A"}</td>
                                    <td style={getPriorityStyle(ticket.priority)}>
                                    {ticket.priority || "N/A"}
                                </td>
                                <td>{ticket.dispenserSrNo || "N/A"}</td>
                                <td>{ticket.issueReported || "N/A"}</td>
                                <td>{ticket.roName || "N/A"}</td>
                                <td>{ticket.roAddress || "N/A"}</td>
                                <td>{ticket.roCity || "N/A"}</td>
                                <td>{ticket.roState || "N/A"}</td>
                                <td>{ticket.roCountry || "N/A"}</td>
                                <td>{ticket.roContact || "N/A"}</td>
                                {/* <td>{ticket.priority || "N/A"}</td> */}
                             
                               
                                {/* <td>{ticket.woStatus || "N/A"}</td>
                                <td>{ticket.omcApprovalStatus || "N/A"}</td> */}
                            </tr>
                        ))}
                    </tbody>
                </Table>

                {tickets.length > rowsPerPage && (
                    <div className="d-flex justify-content-center align-items-center my-3">
                        <Button
                            variant="secondary"
                            size="sm"
                            disabled={currentPage === 1}
                            onClick={() => setCurrentPage((prev) => prev - 1)}
                        >
                            Prev
                        </Button>
                        <span className="mx-3">
                            Page {currentPage} of {totalPages}
                        </span>
                        <Button
                            variant="secondary"
                            size="sm"
                            disabled={currentPage === totalPages}
                            onClick={() => setCurrentPage((prev) => prev + 1)}
                        >
                            Next
                        </Button>
                    </div>
                )}
            </div>
        </Container>
    );
};

export default SlaInprogressTicketList;
